import React from 'react';
export function Footer() {
  return <footer className="bg-brand-primary text-white py-12 px-4" data-id="element-76">
      <div className="max-w-4xl mx-auto text-center" data-id="element-77">
        <h3 className="font-display text-2xl font-bold mb-2" data-id="element-78">
          PSICÓLOGO EN ACCIÓN
        </h3>
        <p className="font-body text-white/80 mb-6" data-id="element-79">
          El Sistema Integral de Consulta Privada
        </p>

        <div className="border-t border-white/20 pt-6 space-y-3" data-id="element-80">
          <p className="font-body text-white/60 text-sm" data-id="element-81">
            📧 digipromarket3@gmail.com
          </p>

          <p className="font-body text-white/60 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-82">
            © PSICÓLOGO EN ACCIÓN 2025 — Todos los derechos reservados.
          </p>

          <p className="font-body text-white/40 text-xs max-w-2xl mx-auto leading-relaxed italic" data-id="element-83">
            Este producto es un recurso formativo digital. No sustituye la
            supervisión clínica ni la formación universitaria reglada.
          </p>
        </div>
      </div>
    </footer>;
}